import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Pagination from '../components/Pagination';
import { useBadges } from '../context/BadgesContext';
import { formatDateTime } from '../utils/date';

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const { refresh } = useBadges();

  useEffect(() => { load(); }, [page]);
  async function load() { const { data } = await api.get('/notifications', { params: { page } }); setNotifications(data.data); setTotal(data.total); }
  // refresh() atualiza o sino e o badge do menu; sem ele o contador so
  // corrigia no proximo ciclo do timer ou ao recarregar a pagina.
  async function markRead(id) { await api.patch(`/notifications/${id}/read`); await load(); refresh(); }
  async function markAllRead() { await api.patch('/notifications/read-all'); await load(); refresh(); }
  async function deleteNotif(id) { await api.delete(`/notifications/${id}`); await load(); refresh(); }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold tracking-tight">Notificações</h1>
        <button className="btn btn-secondary" onClick={markAllRead}>Marcar Todas como Lidas</button>
      </div>
      <div className="bg-surface-100 border rounded-md p-4">
        {notifications.length === 0 ? (
          <div className="text-center py-12 text-ink-muted">Nenhuma notificação</div>
        ) : (
          notifications.map((n) => (
            <div key={n.id} className={`p-3 border-b border-subtle flex justify-between items-start ${!n.read_at ? 'bg-surface-inset' : ''}`}>
              <div>
                <div className={`text-sm ${n.read_at ? 'font-normal' : 'font-semibold'}`}>{n.title}</div>
                <div className="text-sm text-ink-secondary mt-1">{n.message}</div>
                <div className="text-xs text-ink-muted mt-1">{formatDateTime(n.created_at)}</div>
              </div>
              <div className="flex gap-1 flex-shrink-0">
                {!n.read_at && <button className="btn btn-sm btn-secondary" onClick={() => markRead(n.id)}>Lida</button>}
                <button className="btn btn-sm btn-danger" onClick={() => deleteNotif(n.id)}>Excluir</button>
              </div>
            </div>
          ))
        )}
        <Pagination page={page} total={total} limit={10} onPageChange={setPage} />
      </div>
    </div>
  );
}
